module.exports = __webpack_public_path__ + "static/img/banner.3fa4192.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/News/banner.jpg
// module id = cSP7
// module chunks = 1